import { useState } from "react";
import { ActionIcon, Menu } from "@mantine/core";
import { IconDots, IconInfoCircle } from "@tabler/icons-react";
import type { TourConfig, WidgetDefinition } from "@pulse-ui/widget-sdk";

interface WidgetTabMenuProps {
  widgetDef: WidgetDefinition;
  onStartTour: (config: TourConfig) => void;
}

/**
 * "..." menu added to every widget tab's chrome via FlexLayout's onRenderTab.
 * Only renders (and only offers "Take a tour") when the widget declares a tour.
 */
export function WidgetTabMenu({ widgetDef, onStartTour }: WidgetTabMenuProps) {
  const [loadingTour, setLoadingTour] = useState(false);

  if (!widgetDef.tour) return null;
  const loadTour = widgetDef.tour;

  return (
    <Menu position="bottom-end" withinPortal shadow="md">
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          aria-label="Widget options"
          onClick={(e) => e.stopPropagation()}
        >
          <IconDots size={16} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconInfoCircle size={14} />}
          disabled={loadingTour}
          onClick={() => {
            setLoadingTour(true);
            loadTour()
              .then(onStartTour)
              .finally(() => setLoadingTour(false));
          }}
        >
          Take a tour
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
